module.exports = __webpack_public_path__ + "static/img/air1 (2).86c31edf.jpg";